// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBSUY7kgv1YBHlcCvF4N3zqHbQrv-LHCfg",
  authDomain: "efoodiaweb.firebaseapp.com",
  projectId: "efoodiaweb",
  storageBucket: "efoodiaweb.appspot.com",
  messagingSenderId: "71115085769",
  appId: "1:71115085769:web:c404542987df145d33fa18",
  measurementId: "G-62PKDFRR51"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);